interface ResourceInformationProps {
    content: string;
}

export const ResourceInformation = ({ content }: ResourceInformationProps) => (
    <span>{content}</span>
);
